import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import styled from 'styled-components';
import styles from './Header.style';
import Logo from './Logo';
import MobileCTAs from './MobileCTAs';
import TopNav from './TopNav';
import BottomNav from './BottomNav';
import analyticsConstants from '../../../constants/analyticsConstants';
import Hamburger from '../../atoms/Hamburger/Hamburger';
import { BUSINESS_TYPES } from '../../../constants/globalConstants';
import HeaderMultiLocation from '../../organisms/HeaderMultiLocation/HeaderMultiLocation';
import Anchor from '../../atoms/Anchor';
import Mailchimp from '../../atoms/Mailchimp';
import Location from '../../../static/images/icons/Location';
import Search from '../../../static/images/icons/Search';
var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);
  var _super = _createSuper(Header);
  function Header(props) {
    var _this;
    _classCallCheck(this, Header);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "state", {
      isBurgerOpen: false,
      isMultiLocationActive: false,
      bannerDisplay: false,
      bannerText: ''
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var currentState = _this.state.isMultiLocationActive;
      _this.setState({
        isMultiLocationActive: !currentState
      });
    });
    _this.burgerToggle = _this.burgerToggle.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _multiLocationCta$sys;
      var _this$props$globalHea = this.props.globalHeaderData,
        variation = _this$props$globalHea.variation,
        appointmentCta = _this$props$globalHea.appointmentCta,
        primaryCtaIsNotAnAppointmentreservationLink = _this$props$globalHea.primaryCtaIsNotAnAppointmentreservationLink,
        pharmacyCta = _this$props$globalHea.pharmacyCta,
        keyCategoriesCollection = _this$props$globalHea.keyCategoriesCollection,
        utilityLinksCollection = _this$props$globalHea.utilityLinksCollection,
        multiLocationMenuContainers = _this$props$globalHea.multiLocationMenuContainers,
        multiLocationCta = _this$props$globalHea.multiLocationCta,
        viewMoreCtaLabel = _this$props$globalHea.viewMoreCtaLabel,
        mobileCtAs = _this$props$globalHea.mobileCtAs,
        codeBlocksCollection = _this$props$globalHea.codeBlocksCollection,
        isEmergencyBtn = _this$props$globalHea.isEmergencyBtn,
        stickyPrimaryCta = _this$props$globalHea.stickyPrimaryCta;
      var keyCategories = keyCategoriesCollection && keyCategoriesCollection.items;
      var utilityLinks = utilityLinksCollection && utilityLinksCollection.items;
      var variationClass = "nva-global-header-old global-headers ".concat(variation ? variation.toLowerCase().replace(' ', '-') : '', " ").concat(this.props.className);
      var _ref = this.props.yextContactInformationData || '',
        mainPhone = _ref.mainPhone,
        address = _ref.address,
        c_websitePhone = _ref.c_websitePhone,
        c_textPhone = _ref.c_textPhone,
        c_googleMyBusinessCID = _ref.c_googleMyBusinessCID;
      var headerAnalytics = analyticsConstants.globalHeader;
      var siteBusinessType = this.props.siteBusinessType;
      var isNvaMainSite = this.props.isNvaMainSite;
      return __jsx("nav", {
        className: "".concat(variationClass, " ").concat(this.state.isBurgerOpen ? 'burger-open' : 'burger-close')
      }, __jsx("div", {
        className: "main-container"
      }, __jsx("div", {
        className: "header-container"
      }, __jsx(Hamburger, {
        burgerToggle: this.burgerToggle,
        variation: variation,
        isBurgerOpen: this.state.isBurgerOpen,
        "data-analytics-type": headerAnalytics.analyticsType.GLOBAL_NAV,
        "data-analytics-value": headerAnalytics.analyticsValue.GLOBAL_NAV_MOBILE_MENU,
        "data-analytics-variation": variation
      }), __jsx(Logo, {
        className: variationClass,
        variation: variation,
        imageDetails: this.props.imageDetails,
        themeName: this.props.themeName,
        isNvaMainSite: isNvaMainSite
      })), multiLocationCta && !this.state.isBurgerOpen ? __jsx("div", {
        className: "multi-location-cta"
      }, __jsx(Anchor, {
        "data-entry-id": (_multiLocationCta$sys = multiLocationCta.sys) === null || _multiLocationCta$sys === void 0 ? void 0 : _multiLocationCta$sys.id,
        title: multiLocationCta.label || 'Find Location',
        "aria-label": multiLocationCta.ariaLabel,
        to: multiLocationCta.url,
        hyperlinkType: multiLocationCta.hyperlinkType,
        styleType: "primary-anchor",
        className: " nav-btn icon-button",
        ctaBehavior: multiLocationCta.behavior,
        "data-analytics-type": headerAnalytics.analyticsType.GLOBAL_NAV,
        "data-analytics-value": multiLocationCta && multiLocationCta.dataAnalyticsValue ? multiLocationCta.dataAnalyticsValue : headerAnalytics.analyticsValue.GLOBAL_NAV_APPOINTMENT,
        "data-analytics-variation": variation
      }, __jsx(Location, {
        className: "svg-search-icon"
      }), multiLocationCta.label || 'Find Location')) : multiLocationMenuContainers && !this.state.isBurgerOpen ? __jsx("div", {
        className: "multi-location-cta"
      }, __jsx(Anchor, {
        title: viewMoreCtaLabel ? viewMoreCtaLabel : 'Find Location',
        onClick: this.handleClick,
        styleType: "primary-anchor",
        className: " icon-button nav-btn "
      }, __jsx(Search, {
        className: "svg-search-icon"
      }), viewMoreCtaLabel ? viewMoreCtaLabel : 'Find Location')) : '', siteBusinessType !== BUSINESS_TYPES.CORPORATE && __jsx(MobileCTAs, {
        googleMyBusiness: c_googleMyBusinessCID,
        isMultiLocationActive: this.state.isMultiLocationActive,
        handleClick: this.handleClick,
        appointmentCta: appointmentCta,
        displayAppointmentLabel: primaryCtaIsNotAnAppointmentreservationLink,
        pharmacyCta: pharmacyCta,
        isEmergencyBtn: isEmergencyBtn,
        phone: c_websitePhone || mainPhone,
        address: address,
        sms: c_textPhone // to replace with sms
        ,
        isBurgerOpen: this.state.isBurgerOpen,
        variation: variation,
        mobileCTAs: mobileCtAs,
        stickyPrimaryCta: stickyPrimaryCta
      }), __jsx("div", {
        className: "navbar-collapse navbar-links"
      }, utilityLinks && __jsx(TopNav, {
        burgerToggle: this.burgerToggle,
        utilityLinks: utilityLinks,
        yextContactInformationData: this.props.yextContactInformationData,
        phone: this.props.yextContactInformationData && c_websitePhone || this.props.yextContactInformationData && mainPhone,
        address: this.props.yextContactInformationData && address,
        c_websitePhone: this.props.yextContactInformationData && c_websitePhone,
        sms: this.props.yextContactInformationData && c_textPhone,
        className: variationClass,
        variation: variation,
        siteBusinessType: siteBusinessType,
        pharmacyCta: pharmacyCta,
        isEmergencyBtn: isEmergencyBtn,
        appointmentCta: appointmentCta,
        yextMultiLocationdata: this.props.yextMultiLocationdata,
        socialLinks: this.props.globalHeaderData.socialLinks,
        showContactInfoInFooter: this.props.showContactInfoInFooter && this.props.showContactInfoInFooter
      }), keyCategories && __jsx(BottomNav, {
        burgerToggle: this.burgerToggle,
        isMultiLocationActive: this.state.isMultiLocationActive,
        showMultiLocationBtn: multiLocationMenuContainers ? true : false,
        handleClick: this.handleClick,
        keyCategories: keyCategories,
        pharmacyCta: pharmacyCta,
        isEmergencyBtn: isEmergencyBtn,
        appointmentCta: appointmentCta,
        variation: variation,
        viewMoreLabel: viewMoreCtaLabel,
        multiLocationCta: multiLocationCta
      }))), this.state.isMultiLocationActive && __jsx(HeaderMultiLocation, {
        multiLocationMenuContainers: multiLocationMenuContainers,
        themeName: this.props.themeName
      }), codeBlocksCollection && codeBlocksCollection.items && codeBlocksCollection.items.map(function (codeBlock, i) {
        return __jsx("div", {
          className: "codeBlock",
          key: i
        }, __jsx(Mailchimp, {
          mailchimpdata: codeBlock
        }));
      }));
    }
  }, {
    key: "burgerToggle",
    value: function burgerToggle() {
      this.setState(function (state) {
        return {
          isBurgerOpen: !state.isBurgerOpen
        };
      });
      if (this.state.isMultiLocationActive) {
        this.setState({
          isMultiLocationActive: false
        });
      }
    }
  }]);
  return Header;
}(Component);
Header.defaultProps = {
  className: '',
  siteBusinessType: '',
  isNvaMainSite: false
};
export default styled(Header).withConfig({
  componentId: "sc-torseh-0"
})(["", ";"], styles);
export { Header as HeaderVanilla };